import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from './auth-state.service';

// Only a logged-in user who still has first_login = true may reach /set-password
export const firstLoginGuard: CanActivateFn = () => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  if (!authState.isLoggedIn()) return router.createUrlTree(['/login']);
  if (!authState.currentUser()?.first_login) return router.createUrlTree(['/']);

  return true;
};
